module.exports = __webpack_public_path__ + "static/oracle-web-58c091956d4e018468ec9a23c7f91377.jpg";